import { colors } from '../../colors';
import Next from '../../../../static/images/icons/Next';
import Prev from '../../../../static/images/icons/Prev';
var carousel = {
  arrowBgColor: colors.azure,
  arrowHoverBgColor: colors.deepSeaBlue,
  arrowForeColor: colors.white,
  arrowPrevMarginRightVarA: '4px',
  arrowNextMarginLeftVarA: '4px',
  highlightColor: colors.onyx,
  paginationInactiveColor: colors.white,
  paginationActiveColor: colors.azure,
  paginationBorderColor: colors.azure,
  heroPaginationBorder: false,
  noBorderOnDesktopVariationAandB: true,
  heroPaginationInactiveColor: colors.white,
  heroPaginationInactiveColorMobile: colors.azure,
  heroPaginationInactiveColorVariationC: colors.azure,
  heroPaginationActiveColor: colors.azure,
  heroPaginationBorderColor: colors.deepSeaBlue,
  bgColor: colors.whiteish,
  iconNext: Next,
  iconPrev: Prev
};
export default carousel;